import { Input } from '@/presentation/components/inputs/input';
import React from 'react';

type Filters = {
  document: string;
  name: string;
  lastname: string;
  email: string;
};

interface Props {
  onFilter: (filters: Filters) => void;
}

const UsersLoggedFilter: React.FC<Props> = ({ onFilter }) => {
  const [filters, setFilters] = React.useState<Filters>({
    document: '',
    name: '',
    lastname: '',
    email: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const newFilters = { ...filters, [name]: value };
    setFilters(newFilters);
    onFilter(newFilters);
  };

  return (
    <div className="flex flex-wrap gap-2 mb-4">
      <Input
        name="document"
        placeholder="Documento"
        value={filters.document}
        onChange={handleChange}
      />
      <Input
        name="name"
        placeholder="Nombre"
        value={filters.name}
        onChange={handleChange}
      />
      <Input
        name="lastname"
        placeholder="Apellido"
        value={filters.lastname}
        onChange={handleChange}
      />
      <Input
        name="email"
        placeholder="Correo electrónico"
        value={filters.email}
        onChange={handleChange}
      />
    </div>
  );
};

export default UsersLoggedFilter;
